import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {AvataaarDefault} from "../../../../../components/AvataaarDefault";
import {BtnIconMoneyWrapper} from "../../../../../components/BtnIconMoneyWrapper";
import {ClothingGraphic} from "../../../../../components/ClothingGraphic";
import {ClothingShirtScoop} from "../../../../../components/ClothingShirtScoop";
import {EyebrowOutline} from "../../../../../components/EyebrowOutline";
import {EyesDefault} from "../../../../../components/EyesDefault";
import {NoseDefault} from "../../../../../components/NoseDefault";
import {Text} from "../../../../../components/Text";
import {Eyebrow4} from "../../../../../icons/Eyebrow4";
import {Eyes} from "../../../../../icons/Eyes";
import {Eyes1} from "../../../../../icons/Eyes1";
import {EyesWink} from "../../../../../icons/EyesWink";
import {IconSmall2} from "../../../../../icons/IconSmall2";
import {IconlyLightOutlineArrowDown21} from "../../../../../icons/IconlyLightOutlineArrowDown21";
import {Icons19} from "../../../../../icons/Icons19";
import {Mouth} from "../../../../../icons/Mouth";
import {Mouth2} from "../../../../../icons/Mouth2";
import {Nose4} from "../../../../../icons/Nose4";
import {TrailingIcon14} from "../../../../../icons/TrailingIcon14";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const YoungLanding = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const scrollRef = useRef(null);

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-card_details-young-mobile${currentParams}`);
  };
  return (
      <div className="young-landing">
        <div className="div-18">
          <div className="overlap-27">
            <div className="rectangle-35" />

            <div className="element-11">
              <div className="overlap-28">
                {/* <div className="group-40">
                <div className="frame-162">
                  <div className="ellipse-22" />
                </div>
              </div> */}

                {/* <div className="frame-163">
                <div className="ellipse-23" />
              </div> */}

                <header className="header-3">
                  <div className="frame-164">
                    <div className="img-wrapper">
                      <img
                          className="iconly-light-outline-5"
                          alt="Iconly light outline"
                          src="/img/iconly-light-outline-more-square-1.svg"
                      />
                    </div>
                  </div>

                  <div className="frame-165">
                    <div className="frame-166">
                      <div className="group-41">
                        <div className="overlap-29">
                          <div className="iconly-light-outline-6" />

                          <div className="group-42">
                            <div className="overlap-group-32">
                              <div className="text-wrapper-147">3</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-wrapper-148">Mary</div>
                  </div>

                  <div className="gg-crown-wrapper">
                    <div className="gg-crown">
                      <div className="overlap-30">
                        <img className="crown" alt="Crown" src="/img/crown.svg" />

                        <div className="frame-167">
                          <div className="overlap-group-33">
                            <img
                                className="vector-12"
                                alt="Vector"
                                src="/img/vector-12.svg"
                            />

                            <img
                                className="ellipse-24"
                                alt="Ellipse"
                                src="/img/ellipse-18.svg"
                            />

                            <img
                                className="ellipse-25"
                                alt="Ellipse"
                                src="/img/ellipse-20.svg"
                            />

                            <img
                                className="ellipse-26"
                                alt="Ellipse"
                                src="/img/ellipse-19.svg"
                            />

                            <div className="t-tulo-cuenta">2</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>

                <div className="a">
                  <div className="frame-168">
                    <div className="text-wrapper-149">
                      Total Balance | ****2357
                    </div>
                  </div>

                  <div className="frame-169">
                    <Icons19 className="icons-19" color="white" />
                    <div className="group-43">
                      <div className="text-wrapper-150">$</div>

                      <div className="overlap-group-34">
                        <div className="text-wrapper-151">13,000</div>

                        <div className="text-wrapper-152">.23</div>
                      </div>

                      <div className="text-wrapper-153">USD</div>
                    </div>

                    <div className="menu-copy-3">
                      <div className="oval-10" />

                      <div className="oval-11" />

                      <div className="oval-12" />
                    </div>
                  </div>
                </div>

                <div className="b">
                  <div className="frame-170">
                    <button className="button-medium">
                      <div className="icon-nombre">
                        <div className="overlap-31">
                          <div className="icon-transactions">
                            <div className="overlap-group-35">
                              <div className="icon-enviar" />

                              <svg
                                  width={13}
                                  height={18}
                                  viewBox="0 0 13 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                    d="M12.3388 5.19514L7.50746 0.340803C7.27664 0.121914 6.97139 0 6.65415 0C6.33691 0 6.03166 0.121914 5.80084 0.340803L0.969543 5.19514C0.765757 5.4271 0.657587 5.7285 0.66708 6.0379C0.676572 6.3473 0.803013 6.64141 1.02063 6.86029C1.23825 7.07917 1.53067 7.20635 1.83828 7.2159C2.14589 7.22544 2.44555 7.11664 2.67617 6.91168L5.44757 4.12919V12.5417C5.43697 12.7076 5.46031 12.874 5.51615 13.0305C5.57199 13.187 5.65915 13.3303 5.77223 13.4516C5.88531 13.5728 6.02191 13.6695 6.1736 13.7356C6.32529 13.8017 6.48884 13.8358 6.65415 13.8358C6.81946 13.8358 6.98301 13.8017 7.1347 13.7356C7.28638 13.6695 7.42299 13.5728 7.53607 13.4516C7.64915 13.3303 7.7363 13.187 7.79214 13.0305C7.84798 12.874 7.87133 12.7076 7.86073 12.5417V4.12919L10.6272 6.91168C10.8557 7.12884 11.1594 7.24791 11.4737 7.24365C11.7881 7.23938 12.0885 7.11211 12.3111 6.88882C12.5338 6.66554 12.6612 6.36381 12.6663 6.04762C12.6715 5.73143 12.554 5.42565 12.3388 5.19514Z"
                                    fill={colors.secundario}
                                />
                                <path
                                    d="M7.76647 16.2208C7.73493 16.1499 7.69835 16.0813 7.65701 16.0156C7.61385 15.9474 7.562 15.8852 7.50276 15.8305C7.44905 15.7721 7.38896 15.7201 7.32364 15.6753C7.25608 15.6347 7.18632 15.598 7.11467 15.5652C7.04085 15.5344 6.96419 15.5109 6.88579 15.4952C6.72964 15.4652 6.56926 15.4652 6.41311 15.4952C6.33651 15.5116 6.26157 15.5351 6.18921 15.5652C6.11656 15.5959 6.04665 15.6327 5.98023 15.6753C5.91332 15.72 5.85158 15.772 5.79614 15.8305C5.73987 15.8866 5.68982 15.9487 5.64687 16.0156C5.60364 16.0802 5.56697 16.1489 5.53741 16.2208C5.50671 16.2951 5.48338 16.3722 5.46775 16.451C5.45217 16.5268 5.44383 16.6039 5.44287 16.6812C5.4434 16.8411 5.47553 16.9993 5.53741 17.1466C5.56589 17.2206 5.60261 17.2912 5.64687 17.3568C5.73354 17.4908 5.84709 17.605 5.98023 17.6921C6.04554 17.7367 6.11564 17.7736 6.18921 17.8022C6.33566 17.8645 6.49295 17.8968 6.65194 17.8973C6.7297 17.905 6.80802 17.905 6.88579 17.8973C6.96419 17.8816 7.04085 17.8581 7.11467 17.8273C7.18616 17.7975 7.25451 17.7606 7.31867 17.7172C7.38525 17.674 7.44698 17.6236 7.50276 17.567C7.56086 17.5113 7.6126 17.4492 7.65701 17.3819C7.69938 17.3151 7.736 17.2447 7.76647 17.1717C7.82972 17.025 7.86029 16.8661 7.85603 16.7063C7.86362 16.628 7.86362 16.5493 7.85603 16.471C7.83532 16.3846 7.80529 16.3007 7.76647 16.2208Z"
                                    fill={colors.secundario}
                                />
                              </svg>
                            </div>
                          </div>

                          <div className="text-wrapper-154">Send</div>
                        </div>
                      </div>
                    </button>

                    <div className="icon-nombre-wrapper">
                      <div className="icon-nombre-2">
                        <div className="overlap-group-36">
                          <div className="icon-transactions-2" style={{ top: 7 }}>
                            <svg
                                width={13}
                                height={18}
                                viewBox="0 0 13 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                  d="M0.994256 12.8049L5.82555 17.6592C6.05637 17.8781 6.36162 18 6.67886 18C6.9961 18 7.30135 17.8781 7.53217 17.6592L12.3635 12.8049C12.5673 12.5729 12.6754 12.2715 12.6659 11.9621C12.6564 11.6527 12.53 11.3586 12.3124 11.1397C12.0948 10.9208 11.8023 10.7937 11.4947 10.7841C11.1871 10.7746 10.8875 10.8834 10.6568 11.0883L7.88544 13.8708L7.88544 5.45829C7.89604 5.29237 7.8727 5.12602 7.81686 4.96953C7.76102 4.81303 7.67386 4.66972 7.56078 4.54844C7.4477 4.42716 7.3111 4.33049 7.15941 4.26441C7.00772 4.19833 6.84417 4.16423 6.67886 4.16423C6.51355 4.16423 6.35 4.19833 6.19831 4.26441C6.04662 4.33049 5.91002 4.42716 5.79694 4.54844C5.68386 4.66972 5.59671 4.81303 5.54087 4.96953C5.48502 5.12602 5.46168 5.29237 5.47228 5.45829L5.47228 13.8708L2.70586 11.0883C2.47731 10.8712 2.17364 10.7521 1.85926 10.7564C1.54488 10.7606 1.24452 10.8879 1.02188 11.1112C0.799235 11.3345 0.671823 11.6362 0.666667 11.9524C0.66151 12.2686 0.779013 12.5743 0.994256 12.8049Z"
                                  fill={colors.secundario}
                              />
                              <path
                                  d="M5.56654 1.77918C5.59808 1.85013 5.63466 1.91871 5.676 1.98436C5.71916 2.0526 5.77101 2.11485 5.83025 2.16953C5.88396 2.22786 5.94404 2.2799 6.00937 2.32467C6.07692 2.36527 6.14669 2.40203 6.21834 2.43477C6.29215 2.46564 6.36882 2.48911 6.44722 2.50483C6.60336 2.53485 6.76375 2.53485 6.9199 2.50483C6.99649 2.48837 7.07144 2.46492 7.1438 2.43477C7.21645 2.40412 7.28636 2.36729 7.35277 2.32467C7.41968 2.28 7.48143 2.22797 7.53687 2.16953C7.59314 2.11342 7.64319 2.05134 7.68614 1.98436C7.72937 1.91983 7.76604 1.85109 7.7956 1.77918C7.8263 1.70494 7.84963 1.62783 7.86526 1.54897C7.88084 1.47321 7.88917 1.39613 7.89014 1.31877C7.88961 1.15886 7.85748 1.00065 7.7956 0.853353C7.76712 0.779358 7.7304 0.708848 7.68614 0.643166C7.59947 0.509246 7.48592 0.395034 7.35277 0.307865C7.28747 0.263348 7.21737 0.226413 7.1438 0.197766C6.99735 0.13553 6.84005 0.103209 6.68107 0.102681C6.6033 0.0950497 6.52498 0.0950497 6.44722 0.102681C6.36882 0.118399 6.29215 0.141867 6.21834 0.172744C6.14684 0.202474 6.0785 0.23936 6.01434 0.282843C5.94775 0.326038 5.88603 0.376378 5.83025 0.432977C5.77214 0.488737 5.72041 0.550842 5.676 0.618142C5.63363 0.684941 5.59701 0.75526 5.56654 0.828331C5.50329 0.97504 5.47272 1.13389 5.47698 1.29375C5.46939 1.37196 5.46939 1.45074 5.47698 1.52896C5.49769 1.61539 5.52772 1.6993 5.56654 1.77918Z"
                                  fill={colors.secundario}
                              />
                            </svg>
                          </div>

                          <div className="text-wrapper-155">Collect</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="frame-171">
                    <div className="left">
                      <img
                          className="img-6"
                          alt="Solar bus outline"
                          src="/img/solar-bus-outline.svg"
                      />

                      <div className="text-wrapper-156">Top Ups</div>
                    </div>

                    <div className="left">
                      <img
                          className="img-6"
                          alt="File text"
                          src="/img/file-text.svg"
                      />

                      <div className="text-wrapper-156">Pay Bills</div>
                    </div>

                    <div className="left">
                      <img
                          className="img-6"
                          alt="Icons"
                          src="/img/icons-21.svg"
                      />

                      <div className="text-wrapper-156">Hub</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="navs-statusbar-6">
            <div className="content-8">
              <div className="text-wrapper-157">9:50</div>

              <img className="icons-8" alt="Icons" src="/img/icons.svg" />
            </div>
          </div> */}
          </div>

          <div className="overlap-32">
            <div className="rectangle-36" />

            <div className="element-12">
              <div className="inside-2">
                <div className="switch">
                  <div className="btn-switch-2">
                    <div className="element-13">
                      <div className="text-wrapper-158">My Products</div>
                    </div>

                    <div className="element-14">
                      <div className="text-wrapper-159">Winning</div>
                    </div>
                  </div>
                </div>

                <div className="cardss-wrapper">
                  <div className="cardss-2 highlighted-button">
                    <div className="div-19" onClick={handleButtonClick}>
                      <div className="tarjeta-3">
                        <div className="frame-172">
                          <div className="text-wrapper-160">Credit</div>

                          <div className="text-wrapper-161">****5849</div>
                        </div>

                        <img
                            className="uim-master-card"
                            alt="Uim master card"
                            src="/img/uim-master-card.svg"
                        />
                      </div>

                      <div className="frame-173">
                        <div className="text-wrapper-162">GOLD</div>

                        <div className="txt-2">
                          <div className="text-wrapper-163">Available</div>

                          <div className="text-wrapper-164">$ 1,250</div>
                        </div>

                        <div className="frame-174">
                          <div className="text-wrapper-165">02/29</div>

                          <div className="text-wrapper-166">Pay date</div>
                        </div>
                      </div>
                    </div>

                    <div className="div-19">
                      <div className="tarjeta-4">
                        <div className="frame-172">
                          <div className="text-wrapper-160">Credit</div>

                          <div className="text-wrapper-161">****2345</div>
                        </div>

                        <img
                            className="logo-visa-8"
                            alt="Logo visa"
                            src="/img/logo-visa-8.svg"
                        />
                      </div>

                      <div className="frame-173">
                        <div className="text-wrapper-162">SILVER</div>

                        <div className="txt-2">
                          <div className="text-wrapper-163">Available</div>

                          <div className="text-wrapper-164">$ 550.00</div>
                        </div>

                        <div className="frame-174">
                          <div className="text-wrapper-165">09/22</div>

                          <div className="text-wrapper-166">Pay date</div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="div-19">
                    <div className="tarjeta-5">
                      <div className="frame-172">
                        <div className="text-wrapper-160">Debit</div>

                        <div className="text-wrapper-161">****2357</div>
                      </div>

                      <img
                        className="uim-master-card"
                        alt="Uim master card"
                        src="/img/uim-master-card-1.svg"
                      />
                    </div>

                    <div className="frame-173">
                      <div className="text-wrapper-162">Main account</div>

                      <div className="txt-2">
                        <div className="text-wrapper-163">Available</div>

                        <div className="text-wrapper-164">$ 13,000,23</div>
                      </div>
                    </div>

                    <div className="frame-175">
                      <div className="text-wrapper-167">My Wealth</div>

                      <IconlyLightOutlineArrowDown21
                        className="icon-instance-node-6"
                        color="var(--secundario)"
                      />
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="all">
              <div className="element-15">
                <div className="div-20">
                  <div className="subsection-8">
                    <div className="frame-176">
                      <div className="text-wrapper-168">My Goals</div>
                    </div>

                    <div className="iconly-light-outline-7">
                      <div className="text-wrapper-169">Manage</div>
                    </div>
                  </div>

                  <div className="frame-177">
                    <div className="frame-178">
                      <div className="overlap-33">
                        <div className="frame-179">
                          <div className="frame-180">
                            <div className="frame-181">
                              <div className="text-wrapper-170">New iPhone</div>

                              <TrailingIcon14
                                  className="icon-instance-node-6"
                                  color="#0066FF"
                              />
                            </div>

                            <p className="due-date-days">
                              <span className="text-wrapper-171">Due date: </span>

                              <span className="text-wrapper-172">90 days</span>
                            </p>
                          </div>

                          <div className="frame-182">
                            <p className="element-16">
                              <span className="text-wrapper-172">$700.54</span>

                              <span className="text-wrapper-173">
                              {" "}
                                / $950,000
                            </span>
                            </p>

                            <div className="group-46">
                              <div className="overlap-group-37">
                                <Text
                                    className="text-instance"
                                    color="primary"
                                    size="caption"
                                />
                                <Text
                                    className="text-11"
                                    color="primary"
                                    size="caption"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <img
                            className="image-13"
                            alt="Image"
                            src="/img/image-61980-1.png"
                        />
                      </div>
                    </div>

                    {/* <div className="frame-178">
                    <div className="overlap-34">
                      <div className="frame-183">
                        <div className="frame-180">
                          <div className="frame-181">
                            <div className="text-wrapper-170">
                              Europe Travel
                            </div>

                            <TrailingIcon14
                              className="icon-instance-node-6"
                              color="#0066FF"
                            />
                          </div>

                          <p className="due-date-days">
                            <span className="text-wrapper-171">Due date: </span>

                            <span className="text-wrapper-172">450 days</span>
                          </p>
                        </div>

                        <div className="frame-182">
                          <p className="element-16">
                            <span className="text-wrapper-172">$8,700</span>

                            <span className="text-wrapper-173"> / $45,000</span>
                          </p>

                          <div className="group-47">
                            <div className="overlap-group-38">
                              <Text
                                className="text-instance"
                                color="primary"
                                size="caption"
                              />
                              <Text
                                className="text-12"
                                color="primary"
                                size="caption"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <img
                        className="subtract"
                        alt="Subtract"
                        src="/img/subtract.png"
                      />
                    </div>
                  </div> */}

                    {/* <div className="frame-184">
                    <div className="overlap-35">
                      <div className="frame-185">
                        <div className="frame-180">
                          <div className="frame-181">
                            <div className="text-wrapper-170">Xmas gifts</div>

                            <TrailingIcon14
                              className="icon-instance-node-6"
                              color="#0066FF"
                            />
                          </div>

                          <p className="due-date-days">
                            <span className="text-wrapper-171">Due date: </span>

                            <span className="text-wrapper-172">250 days</span>
                          </p>
                        </div>

                        <div className="frame-182">
                          <p className="element-16">
                            <span className="text-wrapper-172">$3,980</span>

                            <span className="text-wrapper-173"> / $5,000</span>
                          </p>

                          <div className="group-47">
                            <div className="overlap-group-38">
                              <Text
                                className="text-instance"
                                color="primary"
                                size="caption"
                              />
                              <Text
                                className="text-12"
                                color="primary"
                                size="caption"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <img
                        className="image-14"
                        alt="Image"
                        src="/img/image-61589.png"
                      />
                    </div>
                  </div> */}
                  </div>
                </div>

                <img
                    className="vector-13"
                    alt="Vector"
                    src="/img/vector-271.svg"
                />
              </div>

              <div className="element-17">
                <div className="div-20">
                  <div className="subsection-9">
                    <div className="frame-176">
                      <div className="text-wrapper-168">Last activity</div>
                    </div>

                    <div className="iconly-light-outline-8">
                      <div className="text-wrapper-169">See all</div>

                      <IconlyLightOutlineArrowDown21
                          className="icon-instance-node-6"
                          color="white"
                      />
                    </div>
                  </div>

                  <div className="frame-186">
                    <div className="frame-187">
                      <div className="overlap-group-39">
                        <img
                            className="vector-14"
                            alt="Vector"
                            src="/img/vector-270-1.svg"
                        />

                        <div className="ellipse-27" />

                        <div className="ellipse-28" />

                        <div className="ellipse-29" />
                      </div>
                    </div>

                    <div className="frame-188">
                      <div className="feed-row-4">
                        <div className="data-3">
                          <div className="btn-icon-money-instance-wrapper">
                            <BtnIconMoneyWrapper />
                          </div>

                          <div className="frame-189">
                            <div className="name-3">Sent - Pamela F.</div>

                            <div className="subject-3">11/06/24</div>
                          </div>
                        </div>

                        <div className="frame-190">
                          <p className="amount-10">
                            <span className="text-wrapper-174">-$1.609</span>

                            <span className="text-wrapper-175">,23</span>
                          </p>

                          <div className="frame-191">
                            <div className="subject-4">Regular transf?</div>

                            <div className="x-smaall">
                              <IconSmall2
                                  className="icon-small"
                                  color="#8E8E8E"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="feed-row-4">
                        <div className="data-4">
                          <img
                              className="frame-192"
                              alt="Frame"
                              src="/img/frame-480954771-6.svg"
                          />

                          <div className="group-48">
                            <div className="overlap-group-40">
                              <div className="name-4">Refund Promo</div>

                              <div className="frame-193">
                                <div className="subject-5">6 h ago</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="frame-194">
                          <p className="amount-11">
                            <span className="text-wrapper-174">+$2.950,</span>

                            <span className="text-wrapper-175">23</span>
                          </p>
                        </div>
                      </div>

                      <div className="feed-row-4">
                        <div className="data-4">
                          <img
                              className="frame-192"
                              alt="Frame"
                              src="/img/frame-480954772-5.svg"
                          />

                          <div className="group-48">
                            <div className="overlap-group-40">
                              <div className="name-4">Mission finished</div>

                              <div className="frame-193">
                                <div className="subject-5">You earn a prize</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="frame-195">
                          <div className="amount-12">+$950,23</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pockets-wrapper">
                <div className="pockets">
                  <div className="subsection-10">
                    <div className="frame-176">
                      <div className="text-wrapper-176">
                        Favorite contacts transfers
                      </div>
                    </div>

                    <div className="iconly-light-outline-7">
                      <div className="text-wrapper-169">Manage</div>
                    </div>
                  </div>

                  <div className="frame-196">
                    <div className="frame-197">
                      <div className="frame-198">
                        <div className="i-hope-your-day-wrapper">
                          <AvataaarDefault
                              body="/img/body-1.png"
                              bodyClassName="i-hope-your-day-2"
                              className="i-hope-your-day"
                              clothingShirtScoopClothingShirtScoop="/img/clothes-3.svg"
                              clothingShirtScoopClothingShirtScoopClassName="design-component-instance-node-4"
                              faceClassName="i-hope-your-day-3"
                              icon={<Mouth2 className="mouth-2" />}
                              icon1={<Eyebrow4 className="eyebrow-4" />}
                              mouthStyleOverrideClassName="avataaar-default-3"
                              overlapClassName="avataaar-default-instance"
                              overlapGroupClassName="avataaar-default-2"
                              override={<Eyes className="eyes-2" />}
                              top="/img/top-1.png"
                              topClassName="i-hope-your-day-4"
                          />
                        </div>
                      </div>

                      <div className="text-wrapper-177">Karol</div>
                    </div>

                    {/* <div className="frame-197">
                    <div className="frame-199">
                      <div className="avataaar-wrapper">
                        <AvataaarDefault
                          body="/img/body-2.png"
                          bodyClassName="avataaar-3"
                          className="avataaar"
                          faceClassName="avataaar-4"
                          icon={
                            <MouthGrimace
                              className="mouth-grimace-instance"
                              mouthGrimace="/img/mouth-grimace-1.svg"
                            />
                          }
                          icon1={<Eyebrow4 className="eyebrow-2" />}
                          mouthStyleOverrideClassName="avataaar-default-3"
                          overlapClassName="avataaar-2"
                          overlapGroupClassName="avataaar-default-2"
                          override={
                            <EyesDefault
                              className="eyes-3"
                              eyeClassName="eyes-4"
                              eyeClassNameOverride="eyes-5"
                            />
                          }
                          override1={
                            <ClothingOverall
                              buttonClassName="clothing-overall-4"
                              buttonClassNameOverride="clothing-overall-5"
                              className="clothing-overall-instance"
                              object="/img/object-1.png"
                              objectClassName="clothing-overall-3"
                              overlapGroupClassName="clothing-overall-2"
                            />
                          }
                          top="/img/top-3.png"
                          topClassName="avataaar-2"
                        />
                      </div>
                    </div>

                    <div className="text-wrapper-178">James</div>
                  </div> */}

                    <div className="frame-197">
                      <div className="frame-200">
                        <AvataaarDefault
                            body="/img/body-4.png"
                            bodyClassName="avataaar-6"
                            className="avataaar-5"
                            faceClassName="avataaar-4"
                            icon={<Mouth className="nose" opacity="0.7" />}
                            icon1={<Eyebrow4 className="eyebrow-2" />}
                            mouthStyleOverrideClassName="avataaar-7"
                            overlapClassName="avataaar-default-instance"
                            overlapGroupClassName="avataaar-default-2"
                            override={<EyesWink className="eyes-wink" />}
                            override1={
                              <ClothingGraphic
                                  className="clothing-graphic-shirt"
                                  clothingGraphic="/img/clothing-graphic-shirt-1.svg"
                              />
                            }
                            top="/img/top-4.png"
                            topClassName="avataaar-8"
                        />
                      </div>

                      <div className="text-wrapper-177">Jean</div>
                    </div>

                    <div className="frame-197">
                      <div className="frame-200">
                        <div className="avataaar-9">
                          <div className="overlap-36">
                            <img
                                className="body-3"
                                alt="Body"
                                src="/img/body-5.png"
                            />

                            <ClothingShirtScoop
                                className="clothes"
                                clothingShirtScoop="/img/clothes-1.svg"
                            />
                            <div className="face-2">
                              <div className="overlap-37">
                                <div className="mouth-eating">
                                  <div className="overlap-group-41">
                                    <div className="om-nom-nom" />

                                    <div className="redish" />

                                    <div className="redish-2" />
                                  </div>
                                </div>

                                <Nose4 className="nose-4" />
                                <EyesDefault
                                    className="eyes-6"
                                    eyeClassName="eyes-7"
                                    eyeClassNameOverride="eyes-8"
                                />
                                <Eyebrow4 className="eyebrow-3" />
                              </div>
                            </div>

                            <img
                                className="top-2"
                                alt="Top"
                                src="/img/top-5.png"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="text-wrapper-177">Norma</div>
                    </div>

                    <div className="frame-197">
                      <div className="frame-198">
                        <div className="i-hope-your-day-wrapper">
                          <AvataaarDefault
                              body="/img/body-1.png"
                              bodyClassName="i-hope-your-day-2"
                              className="i-hope-your-day"
                              faceClassName="i-hope-your-day-3"
                              icon={<Eyes1 className="mouth-2" />}
                              icon1={
                                <EyebrowOutline
                                    className="eyebrow-outline-default"
                                    eyebrowOutline="/img/eyebrow-5.png"
                                />
                              }
                              icon2={
                                <NoseDefault
                                    className="nose-default-instance"
                                    noseDefault="/img/nose-5.png"
                                />
                              }
                              overlapClassName="avataaar-default-instance"
                              overlapGroupClassName="avataaar-default-2"
                              override={<Eyes1 className="eyes-2" />}
                              override1={
                                <ClothingShirtScoop
                                    className="design-component-instance-node-4"
                                    clothingShirtScoop="/img/clothes-2.svg"
                                />
                              }
                              top="/img/top-1.png"
                              topClassName="i-hope-your-day-4"
                          />
                        </div>
                      </div>

                      <div className="text-wrapper-177">Susan</div>
                    </div>

                    {/* <img
                    className="frame-201"
                    alt="Frame"
                    src="/img/frame-480954775-4.png"
                  /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="menu-3">
            <div className="icon-and-text-wrapper">
              <div className="icon-and-text-7">
                <div className="icon-transactions-3">
                  <svg
                      width={13}
                      height={18}
                      viewBox="0 0 13 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M12.3388 5.19514L7.50746 0.340803C7.27664 0.121914 6.97139 0 6.65415 0C6.33691 0 6.03166 0.121914 5.80084 0.340803L0.969543 5.19514C0.765757 5.4271 0.657587 5.7285 0.66708 6.0379C0.676572 6.3473 0.803013 6.64141 1.02063 6.86029C1.23825 7.07917 1.53067 7.20635 1.83828 7.2159C2.14589 7.22544 2.44555 7.11664 2.67617 6.91168L5.44757 4.12919V12.5417C5.43697 12.7076 5.46031 12.874 5.51615 13.0305C5.57199 13.187 5.65915 13.3303 5.77223 13.4516C5.88531 13.5728 6.02191 13.6695 6.1736 13.7356C6.32529 13.8017 6.48884 13.8358 6.65415 13.8358C6.81946 13.8358 6.98301 13.8017 7.1347 13.7356C7.28638 13.6695 7.42299 13.5728 7.53607 13.4516C7.64915 13.3303 7.7363 13.187 7.79214 13.0305C7.84798 12.874 7.87133 12.7076 7.86073 12.5417V4.12919L10.6272 6.91168C10.8557 7.12884 11.1594 7.24791 11.4737 7.24365C11.7881 7.23938 12.0885 7.11211 12.3111 6.88882C12.5338 6.66554 12.6612 6.36381 12.6663 6.04762C12.6715 5.73143 12.554 5.42565 12.3388 5.19514Z"
                        fill={colors.secundario}
                    />
                    <path
                        d="M7.76647 16.2208C7.73493 16.1499 7.69835 16.0813 7.65701 16.0156C7.61385 15.9474 7.562 15.8852 7.50276 15.8305C7.44905 15.7721 7.38896 15.7201 7.32364 15.6753C7.25608 15.6347 7.18632 15.598 7.11467 15.5652C7.04085 15.5344 6.96419 15.5109 6.88579 15.4952C6.72964 15.4652 6.56926 15.4652 6.41311 15.4952C6.33651 15.5116 6.26157 15.5351 6.18921 15.5652C6.11656 15.5959 6.04665 15.6327 5.98023 15.6753C5.91332 15.72 5.85158 15.772 5.79614 15.8305C5.73987 15.8866 5.68982 15.9487 5.64687 16.0156C5.60364 16.0802 5.56697 16.1489 5.53741 16.2208C5.50671 16.2951 5.48338 16.3722 5.46775 16.451C5.45217 16.5268 5.44383 16.6039 5.44287 16.6812C5.4434 16.8411 5.47553 16.9993 5.53741 17.1466C5.56589 17.2206 5.60261 17.2912 5.64687 17.3568C5.73354 17.4908 5.84709 17.605 5.98023 17.6921C6.04554 17.7367 6.11564 17.7736 6.18921 17.8022C6.33566 17.8645 6.49295 17.8968 6.65194 17.8973C6.7297 17.905 6.80802 17.905 6.88579 17.8973C6.96419 17.8816 7.04085 17.8581 7.11467 17.8273C7.18616 17.7975 7.25451 17.7606 7.31867 17.7172C7.38525 17.674 7.44698 17.6236 7.50276 17.567C7.56086 17.5113 7.6126 17.4492 7.65701 17.3819C7.69938 17.3151 7.736 17.2447 7.76647 17.1717C7.82972 17.025 7.86029 16.8661 7.85603 16.7063C7.86362 16.628 7.86362 16.5493 7.85603 16.471C7.83532 16.3846 7.80529 16.3007 7.76647 16.2208Z"
                        fill={colors.secundario}
                    />
                  </svg>
                </div>

                <div className="text-13">Send</div>
              </div>
            </div>

            <div className="icon-and-text-wrapper">
              <div className="icon-and-text-8">
                <div className="icon-transactions-3">
                  <svg
                      width={13}
                      height={18}
                      viewBox="0 0 13 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M0.994256 12.8049L5.82555 17.6592C6.05637 17.8781 6.36162 18 6.67886 18C6.9961 18 7.30135 17.8781 7.53217 17.6592L12.3635 12.8049C12.5673 12.5729 12.6754 12.2715 12.6659 11.9621C12.6564 11.6527 12.53 11.3586 12.3124 11.1397C12.0948 10.9208 11.8023 10.7937 11.4947 10.7841C11.1871 10.7746 10.8875 10.8834 10.6568 11.0883L7.88544 13.8708L7.88544 5.45829C7.89604 5.29237 7.8727 5.12602 7.81686 4.96953C7.76102 4.81303 7.67386 4.66972 7.56078 4.54844C7.4477 4.42716 7.3111 4.33049 7.15941 4.26441C7.00772 4.19833 6.84417 4.16423 6.67886 4.16423C6.51355 4.16423 6.35 4.19833 6.19831 4.26441C6.04662 4.33049 5.91002 4.42716 5.79694 4.54844C5.68386 4.66972 5.59671 4.81303 5.54087 4.96953C5.48502 5.12602 5.46168 5.29237 5.47228 5.45829L5.47228 13.8708L2.70586 11.0883C2.47731 10.8712 2.17364 10.7521 1.85926 10.7564C1.54488 10.7606 1.24452 10.8879 1.02188 11.1112C0.799235 11.3345 0.671823 11.6362 0.666667 11.9524C0.66151 12.2686 0.779013 12.5743 0.994256 12.8049Z"
                        fill={colors.secundario}
                    />
                    <path
                        d="M5.56654 1.77918C5.59808 1.85013 5.63466 1.91871 5.676 1.98436C5.71916 2.0526 5.77101 2.11485 5.83025 2.16953C5.88396 2.22786 5.94404 2.2799 6.00937 2.32467C6.07692 2.36527 6.14669 2.40203 6.21834 2.43477C6.29215 2.46564 6.36882 2.48911 6.44722 2.50483C6.60336 2.53485 6.76375 2.53485 6.9199 2.50483C6.99649 2.48837 7.07144 2.46492 7.1438 2.43477C7.21645 2.40412 7.28636 2.36729 7.35277 2.32467C7.41968 2.28 7.48143 2.22797 7.53687 2.16953C7.59314 2.11342 7.64319 2.05134 7.68614 1.98436C7.72937 1.91983 7.76604 1.85109 7.7956 1.77918C7.8263 1.70494 7.84963 1.62783 7.86526 1.54897C7.88084 1.47321 7.88917 1.39613 7.89014 1.31877C7.88961 1.15886 7.85748 1.00065 7.7956 0.853353C7.76712 0.779358 7.7304 0.708848 7.68614 0.643166C7.59947 0.509246 7.48592 0.395034 7.35277 0.307865C7.28747 0.263348 7.21737 0.226413 7.1438 0.197766C6.99735 0.13553 6.84005 0.103209 6.68107 0.102681C6.6033 0.0950497 6.52498 0.0950497 6.44722 0.102681C6.36882 0.118399 6.29215 0.141867 6.21834 0.172744C6.14684 0.202474 6.0785 0.23936 6.01434 0.282843C5.94775 0.326038 5.88603 0.376378 5.83025 0.432977C5.77214 0.488737 5.72041 0.550842 5.676 0.618142C5.63363 0.684941 5.59701 0.75526 5.56654 0.828331C5.50329 0.97504 5.47272 1.13389 5.47698 1.29375C5.46939 1.37196 5.46939 1.45074 5.47698 1.52896C5.49769 1.61539 5.52772 1.6993 5.56654 1.77918Z"
                        fill={colors.secundario}
                    />
                  </svg>
                </div>

                <div className="text-13">Receive</div>
              </div>
            </div>

            <div className="icon-and-text-wrapper">
              <div className="icon-and-text-9">
                <svg
                    width={20}
                    height={18}
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M11.7019 8.21357H18.5351C18.7653 8.21357 18.986 8.128 19.1488 7.97568C19.3116 7.82337 19.403 7.61678 19.403 7.40138V1.0066C19.4037 0.899526 19.3817 0.793386 19.3384 0.694281C19.2951 0.595176 19.2313 0.505062 19.1506 0.429124C19.07 0.353186 18.9741 0.292923 18.8685 0.251801C18.7628 0.210679 18.6495 0.18951 18.5351 0.189512H11.7019C11.5864 0.188217 11.4717 0.208395 11.3646 0.248877C11.2575 0.289359 11.1599 0.34934 11.0778 0.425343C10.9956 0.501345 10.9303 0.591858 10.8858 0.691634C10.8413 0.791411 10.8184 0.898466 10.8184 1.0066V7.40138C10.8183 7.50928 10.8413 7.61611 10.8859 7.71562C10.9305 7.81513 10.9958 7.90532 11.0781 7.98094C11.1603 8.05655 11.2579 8.11607 11.365 8.15601C11.4721 8.19595 11.5866 8.21552 11.7019 8.21357ZM12.5698 1.81879H17.662V6.58429H12.5698V1.81879Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M8.28446 9.78517H1.45125C1.33684 9.78453 1.2234 9.80506 1.1175 9.84559C1.0116 9.88611 0.915316 9.94584 0.834172 10.0213C0.753028 10.0968 0.688631 10.1866 0.64469 10.2854C0.600748 10.3843 0.578123 10.4903 0.578125 10.5974V16.9921C0.579506 17.208 0.672115 17.4146 0.835704 17.5668C0.999293 17.7189 1.22059 17.8043 1.45125 17.8043H8.28446C8.51602 17.8043 8.73809 17.7183 8.90182 17.565C9.06556 17.4118 9.15755 17.204 9.15755 16.9873V10.5974C9.15755 10.4903 9.13493 10.3843 9.09099 10.2854C9.04705 10.1866 8.98265 10.0968 8.90151 10.0213C8.82036 9.94584 8.72407 9.88611 8.61818 9.84559C8.51228 9.80506 8.39887 9.78453 8.28446 9.78517ZM7.41133 16.18H2.32434V11.4144H7.41133V16.18Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M11.7019 14.6095H18.5351C18.7653 14.6095 18.986 14.5239 19.1488 14.3716C19.3116 14.2193 19.403 14.0127 19.403 13.7973V10.5975C19.386 10.3923 19.2869 10.2007 19.1255 10.061C18.9642 9.92121 18.7524 9.84358 18.5325 9.84358C18.3126 9.84358 18.1009 9.92121 17.9395 10.061C17.7781 10.2007 17.679 10.3923 17.662 10.5975V12.9802H15.989V10.5975C15.989 10.4904 15.9664 10.3844 15.9225 10.2855C15.8785 10.1867 15.8141 10.0969 15.733 10.0214C15.6518 9.94595 15.5555 9.88623 15.4496 9.8457C15.3437 9.80518 15.2303 9.78464 15.1159 9.78529H11.7019C11.5866 9.78334 11.4721 9.80291 11.365 9.84285C11.2579 9.88279 11.1603 9.94231 11.0781 10.0179C10.9958 10.0935 10.9305 10.1837 10.8859 10.2832C10.8413 10.3827 10.8183 10.4896 10.8184 10.5975V13.7973C10.8183 13.9052 10.8413 14.012 10.8859 14.1116C10.9305 14.2111 10.9958 14.3013 11.0781 14.3769C11.1603 14.4525 11.2579 14.512 11.365 14.5519C11.4721 14.5919 11.5866 14.6115 11.7019 14.6095ZM12.5698 11.4146H14.2428V12.9802H12.5698V11.4146Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M15.1163 16.1782H11.7023C11.5823 16.1695 11.4617 16.1841 11.3481 16.2211C11.2344 16.2581 11.1301 16.3167 11.0418 16.3932C10.9535 16.4697 10.883 16.5624 10.8348 16.6656C10.7866 16.7688 10.7617 16.8802 10.7617 16.9929C10.7617 17.1055 10.7866 17.2169 10.8348 17.3201C10.883 17.4233 10.9535 17.5161 11.0418 17.5926C11.1301 17.6691 11.2344 17.7276 11.3481 17.7646C11.4617 17.8016 11.5823 17.8162 11.7023 17.8075H15.1163C15.2363 17.8162 15.3569 17.8016 15.4706 17.7646C15.5843 17.7276 15.6885 17.6691 15.7768 17.5926C15.8652 17.5161 15.9356 17.4233 15.9838 17.3201C16.032 17.2169 16.0569 17.1055 16.0569 16.9929C16.0569 16.8802 16.032 16.7688 15.9838 16.6656C15.9356 16.5624 15.8652 16.4697 15.7768 16.3932C15.6885 16.3167 15.5843 16.2581 15.4706 16.2211C15.3569 16.1841 15.2363 16.1695 15.1163 16.1782Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M19.3845 16.825C19.3635 16.7204 19.3209 16.6207 19.2591 16.5314C19.2282 16.4864 19.1913 16.4453 19.1493 16.4091C18.9818 16.2629 18.7613 16.1816 18.5323 16.1816C18.3033 16.1816 18.0829 16.2629 17.9154 16.4091C17.8765 16.4467 17.8415 16.4876 17.8108 16.5314C17.7779 16.576 17.7499 16.6235 17.7272 16.6733C17.706 16.7222 17.6903 16.7731 17.6801 16.825C17.675 16.8787 17.675 16.9327 17.6801 16.9864C17.6795 17.0931 17.7019 17.1987 17.7459 17.2971C17.7899 17.3955 17.8547 17.4845 17.9363 17.5589C18.0149 17.6358 18.1091 17.6974 18.2134 17.7399C18.3201 17.7787 18.4336 17.7986 18.548 17.7986C18.6629 17.7999 18.7768 17.7793 18.8828 17.7381C18.9889 17.6969 19.0849 17.6359 19.165 17.5589C19.2487 17.4856 19.3131 17.3952 19.3532 17.2947C19.3967 17.197 19.4198 17.0923 19.4211 16.9864C19.4169 16.9313 19.4045 16.877 19.3845 16.825Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M8.28344 0.189819H4.86421C4.63768 0.196203 4.42283 0.285253 4.26554 0.437937C4.10825 0.59062 4.02101 0.794824 4.02248 1.0069V7.40169C4.02248 7.61709 4.11392 7.82368 4.27668 7.97599C4.43943 8.12831 4.66017 8.21388 4.89034 8.21388H8.30958C8.42956 8.22259 8.55017 8.20799 8.66385 8.171C8.77752 8.13401 8.88179 8.07542 8.97012 7.99893C9.05845 7.92243 9.12892 7.82967 9.17712 7.72647C9.22532 7.62327 9.25019 7.51186 9.25019 7.39924C9.25019 7.28661 9.22532 7.17521 9.17712 7.07201C9.12892 6.96881 9.05845 6.87605 8.97012 6.79955C8.88179 6.72305 8.77752 6.66447 8.66385 6.62748C8.55017 6.59049 8.42956 6.57589 8.30958 6.5846H5.76347V5.01893H8.30958C8.54114 5.01893 8.76321 4.93285 8.92694 4.77961C9.09068 4.62638 9.18267 4.41855 9.18267 4.20185V1.0069C9.18272 0.897512 9.15931 0.789225 9.11381 0.688463C9.06831 0.587701 9.00165 0.496516 8.91779 0.420314C8.83392 0.344112 8.73455 0.284445 8.62558 0.244852C8.51662 0.205258 8.40028 0.186544 8.28344 0.189819ZM7.41032 3.38966H5.73733V1.81909H7.41032V3.38966Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M1.45125 5.01857C1.68281 5.01857 1.90488 4.93248 2.06861 4.77925C2.23235 4.62601 2.32434 4.41819 2.32434 4.20148V1.00654C2.32434 0.789833 2.23235 0.582004 2.06861 0.428771C1.90488 0.275538 1.68281 0.189453 1.45125 0.189453C1.21969 0.189453 0.997591 0.275538 0.833853 0.428771C0.670114 0.582004 0.578125 0.789833 0.578125 1.00654V4.20148C0.578125 4.41819 0.670114 4.62601 0.833853 4.77925C0.997591 4.93248 1.21969 5.01857 1.45125 5.01857Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M1.11698 8.15462C1.22323 8.19539 1.33677 8.21697 1.45159 8.21822C1.68224 8.21693 1.90296 8.13027 2.06557 7.97718C2.22818 7.82409 2.31946 7.617 2.31945 7.40114C2.32462 7.34743 2.32462 7.29339 2.31945 7.23968C2.30923 7.18719 2.29166 7.13619 2.26718 7.088C2.24626 7.03989 2.21996 6.99397 2.18875 6.95101C2.15801 6.90445 2.12114 6.86171 2.07898 6.8238C2.03882 6.78738 1.99505 6.75462 1.94827 6.72594C1.90069 6.69513 1.84987 6.6689 1.79664 6.64766C1.74436 6.62784 1.69005 6.61309 1.63456 6.60362C1.49457 6.57754 1.34988 6.58397 1.21316 6.62235C1.07644 6.66073 0.951867 6.7299 0.85034 6.8238C0.808172 6.86171 0.771273 6.90445 0.740537 6.95101C0.709322 6.99397 0.683055 7.03989 0.662133 7.088C0.637655 7.13619 0.620057 7.18719 0.609833 7.23968C0.604665 7.29339 0.604665 7.34743 0.609833 7.40114C0.609666 7.50844 0.632235 7.6147 0.676206 7.7138C0.720177 7.81289 0.784704 7.90285 0.866039 7.97848C0.936258 8.05231 1.02158 8.11221 1.11698 8.15462Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M4.54648 14.5507C4.65233 14.5927 4.76612 14.6143 4.88109 14.6143C4.99605 14.6143 5.10985 14.5927 5.2157 14.5507C5.32167 14.5106 5.41774 14.4507 5.49801 14.3745C5.5777 14.2982 5.64152 14.2086 5.68621 14.1103C5.72811 14.0106 5.7494 13.9044 5.74895 13.7972C5.7501 13.5813 5.65988 13.3737 5.49801 13.2199C5.45678 13.1846 5.41312 13.1519 5.3673 13.122C5.31971 13.0912 5.26893 13.065 5.2157 13.0437C5.16318 13.0246 5.10891 13.0098 5.05359 12.9997C4.91279 12.974 4.76746 12.9807 4.62999 13.019C4.49251 13.0574 4.367 13.1263 4.26417 13.2199C4.10229 13.3737 4.01205 13.5813 4.01319 13.7972C4.01317 14.0129 4.10325 14.2201 4.26417 14.3745C4.34443 14.4507 4.4405 14.5106 4.54648 14.5507Z"
                      fill={colors.secundario}
                  />
                  <path
                      d="M14.9454 3.40478C14.8891 3.41362 14.8345 3.4301 14.7833 3.45371C14.7302 3.47324 14.6794 3.49784 14.6317 3.5271C14.5382 3.58848 14.4568 3.66464 14.3912 3.75217C14.3308 3.8427 14.2867 3.94186 14.2605 4.04573C14.2556 4.09782 14.2556 4.15021 14.2605 4.2023C14.2605 4.419 14.3525 4.62683 14.5162 4.78006C14.68 4.9333 14.9021 5.01938 15.1336 5.01938C15.247 5.02057 15.3594 4.99887 15.463 4.95578C15.5704 4.91825 15.667 4.85796 15.7453 4.77964C15.8276 4.70468 15.8928 4.61485 15.9368 4.5156C15.9808 4.41635 16.0028 4.30976 16.0015 4.2023C16.0009 4.0816 15.9718 3.96251 15.9162 3.85359C15.8607 3.74467 15.78 3.64864 15.68 3.57238C15.58 3.49613 15.4632 3.44155 15.338 3.41257C15.2128 3.38359 15.0823 3.38093 14.9558 3.40478H14.9454Z"
                      fill={colors.secundario}
                  />
                </svg>

                <div className="text-13">QR</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
